"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LOADING_TIMEOUT = exports.ANIMATION_INTERVAL_DURATION = void 0;
var ANIMATION_INTERVAL_DURATION = exports.ANIMATION_INTERVAL_DURATION = 1750;
var DEFAULT_LOADING_TIMEOUT = exports.DEFAULT_LOADING_TIMEOUT = 10000;